/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    Company,
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    HostType,
    HostTypeFromJSON,
    HostTypeFromJSONTyped,
    HostTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfileHostTransformer
 */
export interface ProfileHostTransformer {
    /**
     * 
     * @type {number}
     * @memberof ProfileHostTransformer
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    fiscalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    mobile?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    photoPath?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    devicesCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    devicesCodeUpdated?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileHostTransformer
     */
    devicesCodeToSave?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileHostTransformer
     */
    cardId?: number;
    /**
     * 
     * @type {HostType}
     * @memberof ProfileHostTransformer
     */
    type?: HostType;
    /**
     * 
     * @type {number}
     * @memberof ProfileHostTransformer
     */
    usageThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileHostTransformer
     */
    creditBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileHostTransformer
     */
    boundCreditBalance?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileHostTransformer
     */
    hasCompanyData?: boolean;
    /**
     * 
     * @type {Address}
     * @memberof ProfileHostTransformer
     */
    address?: Address;
    /**
     * 
     * @type {Company}
     * @memberof ProfileHostTransformer
     */
    company?: Company;
}

export function ProfileHostTransformerFromJSON(json: any): ProfileHostTransformer {
    return ProfileHostTransformerFromJSONTyped(json, false);
}

export function ProfileHostTransformerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileHostTransformer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'firstName': !exists(json, 'first_name') ? undefined : json['first_name'],
        'lastName': !exists(json, 'last_name') ? undefined : json['last_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'fiscalCode': !exists(json, 'fiscal_code') ? undefined : json['fiscal_code'],
        'mobile': !exists(json, 'mobile') ? undefined : json['mobile'],
        'photoPath': !exists(json, 'photo_path') ? undefined : json['photo_path'],
        'devicesCode': !exists(json, 'devices_code') ? undefined : json['devices_code'],
        'devicesCodeUpdated': !exists(json, 'devices_code_updated') ? undefined : json['devices_code_updated'],
        'devicesCodeToSave': !exists(json, 'devices_code_to_save') ? undefined : json['devices_code_to_save'],
        'cardId': !exists(json, 'card_id') ? undefined : json['card_id'],
        'type': !exists(json, 'type') ? undefined : HostTypeFromJSON(json['type']),
        'usageThreshold': !exists(json, 'usage_threshold') ? undefined : json['usage_threshold'],
        'creditBalance': !exists(json, 'credit_balance') ? undefined : json['credit_balance'],
        'boundCreditBalance': !exists(json, 'bound_credit_balance') ? undefined : json['bound_credit_balance'],
        'hasCompanyData': !exists(json, 'has_company_data') ? undefined : json['has_company_data'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'company': !exists(json, 'company') ? undefined : CompanyFromJSON(json['company']),
    };
}

export function ProfileHostTransformerToJSON(value?: ProfileHostTransformer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'email': value.email,
        'name': value.name,
        'fiscal_code': value.fiscalCode,
        'mobile': value.mobile,
        'photo_path': value.photoPath,
        'devices_code': value.devicesCode,
        'devices_code_updated': value.devicesCodeUpdated,
        'devices_code_to_save': value.devicesCodeToSave,
        'card_id': value.cardId,
        'type': HostTypeToJSON(value.type),
        'usage_threshold': value.usageThreshold,
        'credit_balance': value.creditBalance,
        'bound_credit_balance': value.boundCreditBalance,
        'has_company_data': value.hasCompanyData,
        'address': AddressToJSON(value.address),
        'company': CompanyToJSON(value.company),
    };
}

